import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/ocorrencia'

class OcorrenciaApiClient {
	async buscarOcorrencias(paginacao, filtro) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${filtro.idEntidade}/todas`,
			pagingAndSorting: paginacao,
			filters: filtro,
		}).build()

		return await axios.get(url)
	}
	async inserirOcorrencia(objParam) {
		return await axios.post(`${URL_PATH}/inserir`, objParam)
	}

	async enviarRespostaOcorrencia(objParam) {
		return await axios.post(`${URL_PATH}/${objParam.idEntidade}/respostas`, objParam)
	}

	async editarRespostaOcorrencia(payload) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/respostas/${payload.idResposta}`,
		}).build()
		return await axios.put(url, payload)
	}

	async visualizarOcorrencia(payload) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${payload.idOcorrencia}/visualizar`,
			filters: { directionDataCriacao: 'DESC', ...payload },
		}).build()
		return await axios.get(url)
	}

	async excluirRespostaOcorrencia(objParam) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/excluir`,
			filters: objParam,
		}).build()

		return await axios.delete(url)
	}

	async atualizarOcorrencia(payload) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${payload.idEntidade}/tramitacao`,
		}).build()
		return await axios.put(url, payload)
	}

	async editarOcorrencia(objParam) {
		return await axios.put(`${URL_PATH}/${objParam.idOcorrencia}/editar`, objParam)
	}
}

export default new OcorrenciaApiClient()
